module.exports = __webpack_public_path__ + "static/logo-e8f61d64713b0192c5cd75daefaa5a98.png";